import React, { useEffect } from "react";
import { useJudgeMe } from "~hooks";

const Reviews = () => {
  const { installed, reload } = useJudgeMe();

  useEffect(() => {
    if (!installed) {
      return;
    }

    reload();
  }, [installed]);

  return (
    <article>
      <div className="jdgm-carousel-wrapper" />
    </article>
  );
};

export default Reviews;
